export const GET_AUDITS_REQUEST = 'GET_AUDITS_REQUEST';
export const GET_AUDITS_SUCCESS = 'GET_AUDITS_SUCCESS';
export const GET_AUDITS_FAILURE = 'GET_AUDITS_FAILURE';
export const SET_AUDITS_ORDER = 'SET_AUDITS_ORDER';
export const SET_AUDITS_PAGE = 'SET_AUDITS_PAGE';
export const SET_AUDITS_SEARCH = 'SET_AUDITS_SEARCH';